import React from "react";
import { View, FlatList, Dimensions } from "react-native";

import MultiplayerPlayerCard from "./MultiplayerPlayerCard";

const { width: screenWidth } = Dimensions.get('window');
const isSmallScreen = screenWidth < 375;

interface LeaderboardPlayer {
  user_id: string;
  [key: string]: unknown;
}

interface LeaderboardProfile {
  id?: string;
  [key: string]: unknown;
}

interface ResultsLeaderboardProps {
  sortedLeaderboard: LeaderboardPlayer[];
  profile: LeaderboardProfile;
  badgeLotties: Record<string, unknown>;
}

const ResultsLeaderboard: React.FC<ResultsLeaderboardProps> = ({
  sortedLeaderboard,
  profile,
  badgeLotties,
}) => {
  if (sortedLeaderboard.length > 10) {
    return (
      <View style={{ 
        width: '100%', 
        marginTop: isSmallScreen ? 20 : 32,
        paddingHorizontal: isSmallScreen ? 8 : 12
      }}>
        <FlatList
          data={sortedLeaderboard}
          keyExtractor={(item) => item.user_id}
          renderItem={({ item, index }) => (
            <MultiplayerPlayerCard
              player={item}
              index={index}
              profile={profile}
              badgeLotties={badgeLotties}
            />
          )}
          contentContainerStyle={{ 
            width: '100%',
            paddingBottom: isSmallScreen ? 16 : 24
          }}
          showsVerticalScrollIndicator={false}
        />
      </View>
    );
  }
  return (
      <View style={{
        width: '100%',
        marginTop: isSmallScreen ? 6 : 10,
        paddingHorizontal: isSmallScreen ? 2 : 4
      }}>
      {sortedLeaderboard.map((p, idx: number) => (
        <MultiplayerPlayerCard
          key={p.user_id}
          player={p}
          index={idx}
          profile={profile}
          badgeLotties={badgeLotties}
        />
      ))}
    </View>
  );
};

export default ResultsLeaderboard;
